<template>
    <div class="create-visit-form__upload" :class="typeClass">
        <label :for="field.id" class="create-visit-form__upload--label">
            <span class="create-visit-form__upload--text">{{ field.label }}</span>
            <div v-html="uploadSvg" class="create-visit-form__upload--svg"></div>
            <input :id="field.id" class="show-for-sr" type="file" :name="field.name" :required="field.required" accept="image/*" @change="setFileName($event)">
            <span v-if="fileName" class="create-visit-form__upload--filename">{{ fileName }}</span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'UploadField',
    props: ['field'],
    data() {
        return {
            fileName: null,
        }
    },
    computed: {
        uploadSvg () {
            return this.$store.state.uploadSvg;
        },
        getType () {
            return this.$store.state.formType;
        },
        typeClass () {
            return {
                'create-visit-form__upload--interest': this.getType === "intresseanmalan",
                'create-visit-form__upload--visit': this.getType === "registrerabesok"
            }
        }
    },
    methods: {
        setFileName(e) {
            this.fileName = e.target.files.length ? e.target.files[0].name : null;
        }
    },
    mounted() {
        document.querySelector('.create-visit-form__form').addEventListener('reset', () => {
            this.fileName = '';
        })
    }
}
</script>